import { useState } from 'react';
import { useRestaurant } from '../../context/RestaurantContext';

const useSaveTalent = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [talentExist, setTalentExist] = useState()
    const { restaurantId } = useRestaurant();

    const saveTalent = async (employeeId) => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/talent-pool`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ employeeId, restaurantId }),
            });


            if (!response.ok) {
                const errorText = await response.text();
                throw new Error('Failed to save talent');
            }

            const talentData = await response.json();
         
            setTalentExist(true);
            
        } catch (error) {
            setError(error);
        } finally {
            setIsLoading(false);
        }
    };

    const checkTalentExistence = async (employeeId) => {
        if (!restaurantId) {
            return;
        }
        
        try {
            const url = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/talent-pool/check?employeeId=${employeeId}&restaurantId=${restaurantId}`;
            
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Failed to check talent existence');
            }

            const { exists } = await response.json();
           
            setTalentExist(exists);

        } catch (error) {
            return false; 
        } finally {
            console.log('checkTalentExistence function completed');
        }
    };

    return { saveTalent, checkTalentExistence, isLoading, error, talentExist };
};

export default useSaveTalent;
